import { CommonModule } from '@angular/common';
import { Component, inject, input, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PatronAddressModel, TransactionWrapper } from '@core/models';
import { ConfigurationService } from '@core/services';
import { TransactionService } from '@core/services/transaction.service';
import { PaymentDetails } from '../../models/payment-details.model';

@Component({
  selector: 'app-checkout-recap',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './checkout-recap.component.html',
  styleUrl: './checkout-recap.component.scss',
})
export class CheckoutRecapComponent {
  configurationService = inject(ConfigurationService);
  transactionService = inject(TransactionService);

  public isTicketFeeEnabled = input.required<boolean>();
  @Input() transaction: TransactionWrapper;
  @Input() paymentDetails: Omit<
    PaymentDetails,
    | 'paymentMethod'
    | 'cardType'
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'address'
  > & {
    paymentMethod: string | null;
    cardType: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    address:
      | (Omit<PatronAddressModel, 'city' | 'postalCode' | 'address1'> & {
          city: string | null;
          postalCode: string | null;
          address1: string | null;
        })
      | null;
    phone: {
      phone: string;
      countryCode: string;
    } | null;
  } = {
    nonce: null,
    paymentMethod: null,
    cardType: null,
    acceptedTerms: false,
    firstName: null,
    lastName: null,
    email: null,
    digitalWallet: null,
    accountCredit: {
      credits: 0,
      payFull: false,
    },
    address: null,
    phone: null,
  };

  get serviceChargesDetails() {
    return this.transactionService.getServiceChargesDetails(
      this.transaction.transaction.tdcTransaction!
    );
  }
}
